import React, {useEffect} from 'react';
import {useField} from 'formik';
import {Form} from "react-bootstrap";

// import { select } from 'tail.select/js/tail.select-es6';
import * as select from 'tail.select';

import {useSelector} from "react-redux";
import SummaryItem from "../components/SummaryItem/SummaryItem";

export default function StateDrivenSelectInput(props) {
  const {label, statePath, stateMappingFunction, placeholder, ...rest} = props;
  const [field, meta, helper] = useField(props);
  const {setValue} = helper;
  const {summaryMode} = rest;

  const customState = useSelector(state => {
    return state[statePath]
  });

  let options = [];
  if (customState) {
    options = stateMappingFunction(customState);
  }

  const fieldRefClass = 'select-' + field.name;

  useEffect(() => {
    const _onChange = (item) => {
      setValue(item.key);
    }
    // eslint-disable-next-line
    let SelectField = null;
    const actSelect = () => {
      SelectField = select('.' + fieldRefClass, {
        classNames: "gcap-tail-select default",     // For our demonstration only
        descriptions: true,
        placeholder: placeholder,
        locale: "it",
        width: "100%",
      })
      if (SelectField) {
        SelectField.on("change", _onChange);
      } 


    }
    actSelect();
    return () => {
      document.removeEventListener('DOMContentLoaded', actSelect);
    };
    // eslint-disable-next-line
  }, [fieldRefClass, placeholder]);

  return (
    <Form.Group className={(meta.touched && meta.error) ? 'has-error' : ''}>
      {
        !summaryMode ? (
          <>
            <div>
              <Form.Label htmlFor="disabledSelect">{label}</Form.Label>
            </div>
            <Form.Control as="select"
                          className={`${fieldRefClass} ${(meta.touched && meta.error) ? 'is-invalid' : ''}`} {...field}
                          value={field.value}>
              {options.map(option => option && <option value={option.value} key={option.value}>{option.label}</option>)}
            </Form.Control>

            {(meta.touched && meta.error) && <div className="invalid-feedback" style={{display: 'block'}}>{meta.error}</div>}
          </>
        ) : (
          <>
            <span className="paragraph-small-fs9">{label}</span>
            <SummaryItem value={field.value} error={meta.error} />
          </>
        )
      }

    </Form.Group>
  );
}
